<!-- Featured Buttons -->
<div class="row">
    <div class="col-md-12">
        <div class="col-md-4">
            <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" placement="bottom" [disabled]="massListCount < 1" ngbTooltip="Print List" (click)="print2()">
                <i class="fa fa-lg fa-print"></i>
                <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Print</span>
            </button>

            <div class="btn-group mr-1">
                <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="massListCount < 1">
                    <i class="fa fa-lg fa-download"></i>
                    <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Export</span>
                </button>
                <div class="dropdown-menu fs-12">
                    <a (click)="massManagemen_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                    <a (click)="massManagement_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                    <a (click)="massManagement_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                </div>
            </div>

            <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1" (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
                <i class="fa fa-lg fa-filter"></i>
                <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Filter</span>
            </button>

            <div class="btn-group mb-1">
                <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="sr-only">Toggle Dropdown</span>
                    <i class="fa fa-lg fa-check-square-o"></i>
                    <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
                </button>
                <div class="dropdown-menu fs-12" style="width: 150px;">
                    <div class="col-md-12 mb-3 fs-12">
                       <input type="checkbox" [(ngModel)]="showManifest"> Manifest No.<br/>
                       <input type="checkbox" [(ngModel)]="showRunType"> Run Type<br/>
                       <input type="checkbox" [(ngModel)]="showDriver"> Driver/s<br/>
                       <input type="checkbox" [(ngModel)]="showFleet"> Fleet/s<br/>
                       <input type="checkbox" [(ngModel)]="showRoute"> Route<br/>
                       <input type="checkbox" [(ngModel)]="showTruckAxle"> Truck Axle<br/>
                       <input type="checkbox" [(ngModel)]="showTrailerAxle"> Trailer Axle<br/>
                       <input type="checkbox" [(ngModel)]="showStartDateTime"> Start Date & Time<br/>
                       <input type="checkbox" [(ngModel)]="showSDPFile"> SDP<br/>
                       <input type="checkbox" [(ngModel)]="showCompliance"> Status<br/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> <br>
<!-- End of Featured Buttons -->

<!-- Search Engine -->
<div class="row" *ngIf="showFilters">
    <div class="col-md-12">
        <div class="col-md-12">
            <div widget class="card border-12 box-shadow" *ngIf="showFilters">
                <div class="text-muted border-4 mb-4"></div>
                <div class="card-body pt-0 widget-body">
                    <div class="widget-controls"> 
                        <a data-widgster="close"class="transition" (click)="toggleFilters()">
                            <i class="fa fa-times"></i>
                        </a>
                    </div>  
                    <div class="row">
                        <div class="col-md-2">
                            <div class="form-group">
                                <label><b>Manifest No.</b></label> 
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="filterControlNo" (keyup)="updateFilter()">
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group">
                                <label><b>Driver:</b></label> 
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="filterMDriver" (keyup)="updateFilter()">
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group">
                                <label><b>Fleet:</b></label> 
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="filterRego" (keyup)="updateFilter()">
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group">
                                <label><b>Start Date:</b></label> 
                                <input type="date" class="form-control form-control-sm" [(ngModel)]="filterDate" (change)="updateFilter()">
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group">
                                <label><b>Routes:</b></label> 
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="filterRoute" (keyup)="updateFilter()">
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="!isFilterEmpty">
                        <div class="col-md-12">
                            <button type="button" class="btn btn-sm btn-success btn-sm mb-1" (click)="resetFilters()">
                                <span>Reset Filter</span>
                            </button>
                        </div>                           
                    </div>                                  
                </div>
            </div>
        </div> 
    </div>
</div>
<!-- End of Search Engine -->

<br *ngIf="showFilters" />
<!-- MASS MANAGEMENT TABLE -->
<div class="card-body pt-0 widget-body">
    <ngx-loading [show]="loadingIndicator"></ngx-loading>
    <ngx-datatable *ngIf="massListCount > 0 && !loadingIndicator"
        [loadingIndicator]="loadingIndicator"
        class="material"
        [rows]="mass_list"
        [columnMode]="'force'"
        [footerHeight]="40"
        [rowHeight]="'auto'"
        [limit]="10"
        [selected]="selected"
        [selectionType]="'single'">

        <ngx-datatable-column prop="control_no" name="Manifest No" headerClass="header" *ngIf="showManifest">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <span class="badge badge-pill badge-warning mr-1" *ngIf="row.changeover_run_id != null">C</span>  <span> <a [routerLink]="['/dispatch/manifestdetails/', row.run_id]" target="_blank">{{ row.control_no }}</a></span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="run_type" name="Run Type" headerClass="header" *ngIf="showRunType"></ngx-datatable-column>

        <ngx-datatable-column prop="collated_drivers" name="Driver/s" headerClass="header" *ngIf="showDriver"></ngx-datatable-column>

        <ngx-datatable-column prop="collated_equipments" name="Fleet/s" headerClass="header" *ngIf="showFleet"></ngx-datatable-column>

        <ngx-datatable-column prop="routes" name="Route" headerClass="header" *ngIf="showRoute">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <span>{{ (row.routes !== null) ? (row.routes) : "No applicable data" }}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="truck_axle" name="Truck Axles" headerClass="header" *ngIf="showTruckAxle">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <span>{{ (row.truck_axle !== null) ? (row.truck_axle) : "No applicable data" }}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="trailer_axle" name="Trailer Axles" headerClass="header" *ngIf="showTrailerAxle">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <span>{{ (row.trailer_axle !== '' &&  row.trailer_axle !== null) ? (row.trailer_axle) : "No applicable data" }}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="latest_date" name="Start Date" headerClass="header" *ngIf="showStartDateTime">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <span>{{ (row.latest_date !== null && row.latest_date != '0000-00-00' ) ? (row.latest_date | date: 'dd MMM yyyy') : ""  }}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="sdp" name="SDP File" headerClass="header" *ngIf="showSDPFile">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <span>
                    <a href="{{folderPath}}/sdp/{{row.sdp}}" target="_blank" >{{row.sdp}}</a>
                </span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="is_compliant" name="Status" headerClass="header" *ngIf="showCompliance">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{ value == 1 ? "Compliant" : "Non-Compliant" }}
            </ng-template>
        </ngx-datatable-column>
        
    </ngx-datatable>
</div> 
<!-- END OF MASS MANAGEMENT TABLE -->

<!-- START PRINT-->
<div id="print-section2" style="display:none">
    <table style="width:100%">
        <tr>
            <th align="left" *ngIf="showManifest">Manifest No.</th>
            <th align="left" *ngIf="showRunType">Run Type</th>
            <th align="left" *ngIf="showDriver">Driver/s</th>
            <th align="left" *ngIf="showFleet">Fleet/s</th>
            <th align="left" *ngIf="showRoute">Route</th>
            <th align="left" *ngIf="showTruckAxle">Truck Axle</th>
            <th align="left" *ngIf="showTrailerAxle">Trailer Axle</th>
            <th align="left" *ngIf="showStartDateTime">Start Date</th> 
            <th align="left" *ngIf="showSDPFile">SDP</th> 
            <th align="left" *ngIf="showCompliance">Status</th> 
        </tr>

        <tr *ngFor="let rw of mass_list"> 
            <td *ngIf="showManifest">{{rw.control_no}}</td>
            <td *ngIf="showRunType">{{rw.run_type}}</td>
            <td *ngIf="showDriver">{{rw.collated_drivers}}</td>
            <td *ngIf="showFleet">{{rw.collated_equipments}}</td>
            <td *ngIf="showRoute">{{rw.routes}}</td>
            <td *ngIf="showTruckAxle">{{rw.truck_axle}}</td>
            <td *ngIf="showTrailerAxle">{{rw.trailer_axle}}</td>
            <td *ngIf="showStartDateTime">{{ (rw.latest_date !== null && rw.latest_date != '0000-00-00') ? (rw.latest_date | date: 'dd MMM yyyy') : "No Date" }}</td> 
            <td *ngIf="showSDPFile">{{rw.sdp}}</td>    
            <td *ngIf="showCompliance">{{ rw.is_compliant == 1 ? "Compliant" : "Non-Compliant"  }}</td>
        </tr>
    </table>
</div>
<!-- END PRINT -->
